/**
 * Modulo do component Minha Turma Detail (minhaTurmaDetail)
 */
(function(){
	angular.module('minhaTurmaModule', []);
})();